<template>
  <v-card class="pa-6">
    <div class="d-flex align-center">
      <v-spacer></v-spacer>
      <h2 class="ml-12">{{ isEditing ? 'Atualizar' : 'Novo' }} Ponto</h2>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-divider class="mt-2 mb-3"></v-divider>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12" sm="9">
          <label>Ponto</label>
          <v-text-field
            type="number"
            v-model="range.range"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite o ponto"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <label>K</label>
          <v-text-field
            type="number"
            v-model="range.k"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite o K"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <label>Incerteza</label>
          <v-text-field
            type="number"
            v-model="range.uncertainty"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite a incerteza"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <label>Tendência</label>
          <v-text-field
            type="number"
            v-model="range.tendency"
            hide-details="auto"
            :disabled="loading"
            placeholder="Digite a tendência"
            outlined
            class="primary-input"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex px-1 mt-3">
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        :loading="loading"
        @click="submit"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'

export default {
  name: 'ManageRangeRange',

  props: {
    selectedRange: Object,
    metricId: Number,
  },

  data() {
    return {
      loading: false,
      range: {},
      apiService: new ApiService(),
      isEditing: false,
    }
  },

  created() {
    this.range.metricId = this.metricId

    if (this.selectedRange) {
      this.range = { ...this.selectedRange }
      this.isEditing = true
    }
  },

  methods: {
    submit() {
      if (!this.$refs.form.validate()) return

      this.range.range = this.range.range.toString().replace(',', '.')
      this.range.k = this.range.k.toString().replace(',', '.')
      this.range.uncertainty = this.range.uncertainty
        .toString()
        .replace(',', '.')
      this.range.tendency = this.range.tendency.toString().replace(',', '.')

      if (this.isEditing) this.edit()
      else this.add()
    },

    add() {
      this.loading = true

      this.apiService
        .post('calibration/v2/pattern/metric/range', this.range)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.apiService
        .put('calibration/v2/pattern/metric/range', this.range)
        .then(() => {
          this.$toast.success('Métrica adicionada com sucesso!')
          this.loading = false
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style></style>
